import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { MaintenanceGate } from "@/components/Maintenance";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import AcceptInvite from "@/pages/AcceptInvite";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import HomeDash from "@/pages/dashboard/HomeDash";
import Robots from "@/pages/dashboard/Robots";
import Account from "@/pages/dashboard/Account";
import ConnectAccount from "@/pages/dashboard/ConnectAccount";
import Quotes from "@/pages/dashboard/Quotes";
import Pairs from "@/pages/dashboard/Pairs";
import AIActivity from "@/pages/dashboard/AIActivity";
import BinarySignal from "@/pages/dashboard/BinarySignal";
import PocketBot from "@/pages/dashboard/PocketBot";
import Settings from "@/pages/dashboard/Settings";
import SmartCpi from "@/pages/dashboard/SmartCpi";
import Signals from "@/pages/dashboard/Signals";
import Billing from "@/pages/dashboard/Billing";
import Admin from "@/pages/Admin";
import PartnerDashboard from "@/pages/PartnerDashboard";
import Referral from "@/pages/Referral";
import PaymentReturn from "@/pages/PaymentReturn";

// Referral subdomains (e.g. https://pbadge.trzefxpro.com) open the partner's landing page.
// Requires a wildcard DNS record (*.trzefxpro.com) configured at the domain provider.
const APEX_DOMAIN = "trzefxpro.com";
function SubdomainReferral() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const host = window.location.hostname;
    if (host === APEX_DOMAIN || host === `www.${APEX_DOMAIN}` || !host.endsWith(`.${APEX_DOMAIN}`)) return;
    const sub = host.slice(0, host.length - (`.${APEX_DOMAIN}`).length);
    if (!sub || sub === "www" || sub.includes(".")) return;
    if (location.pathname === "/") navigate(`/r/${sub}`, { replace: true });
  }, [location.pathname, navigate]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <SubdomainReferral />
          <MaintenanceGate>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/r/:code" element={<Referral />} />
            <Route path="/payment/success" element={<PaymentReturn />} />
            <Route path="/payment/cancel" element={<PaymentReturn />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/app" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<HomeDash />} />
              <Route path="robots" element={<Robots />} />
              <Route path="account" element={<Account />} />
              <Route path="account/connect" element={<ConnectAccount />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="pairs" element={<Pairs />} />
              <Route path="signals" element={<Signals />} />
              <Route path="cpi" element={<SmartCpi />} />
              <Route path="ai-activity" element={<AIActivity />} />
              <Route path="settings" element={<Settings />} />
              <Route path="billing" element={<Billing />} />
            </Route>
            <Route path="/binary-signal" element={<ProtectedRoute><BinarySignal /></ProtectedRoute>} />
            <Route path="/pocket-bot" element={<ProtectedRoute><PocketBot /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="/partner" element={<ProtectedRoute partnerOnly><PartnerDashboard /></ProtectedRoute>} />
          </Routes>
          </MaintenanceGate>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
